import React, { useEffect, useState } from 'react'
import IMG_ISOTIPO_CONCURSO from '../../assets/img/isotipo-concurso.png'
import { useNavigate } from 'react-router-dom';
import sessionUtils from '../../utilities/SessionHandler'
import companyUserService from '../../services/companyUsers';
import ModalComponent from '../../components/Private/ModalComponent';

export default function PasswordRequest() {

    const navigateTo = useNavigate()

    const [callbackData, setCallbackData] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [modalTitle, setModalTitle] = useState('')
    const [modalBody, setModalBody] = useState('')

    const [formData, setFormData] = useState(
        { companyUserEmail: '' }
    )

    const handleRemoveCredentials = () => {
        sessionUtils.removeCredentials()
    }

    const handleInputChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value
        })
    }

    const handleCallbackOnHide = (data) => {
        navigateTo(data.destination)
    }

    const handleSubmit = async () => {
        try {
            const result = await companyUserService.requestPasswordRecovery(formData);

            setModalTitle('Éxito')
            setModalBody('Se ha enviado un correo electrónico con las instrucciones para restablecer tu contraseña')
            setShowModal(true)
            setFormData({ companyUserEmail: '' })

            setCallbackData({ destination: "/" })

        } catch (error) {

            console.log(error)

            setModalTitle('Error')
            setModalBody(error.response.data.messages.error)
            setShowModal(true)

            setCallbackData({ destination: "/sign-in" })
        }
    }

    const renderPasswordRequestForm = () => {
        return (
            <>
                <div className="form-outline mb-4">
                    <input
                        type="email"
                        className="form-control form-control-lg rounded-pill"
                        placeholder="Email"
                        onChange={handleInputChange}
                        name="companyUserEmail"
                        value={formData.companyUserEmail}
                    />
                </div>
                <input
                    type="button"
                    className="btn btn-primary rounded-pill w-100 my-3 py-2 text-white"
                    value="Enviar"
                    onClick={handleSubmit}
                />
                <input
                    type="button"
                    className="btn btn-outline-primary rounded-pill w-100 my-3 py-2 text-primary"
                    value="Volver"
                    onClick={() => navigateTo('/')}
                />
            </>
        )
    }

    useEffect(() => {
        handleRemoveCredentials();
    }, []);

    return (

        <>
            <main id="welcome">
                <div className="container-fluid vh-100">
                    <div className="row">
                        <div className="vh-100 col-md-12 d-flex align-items-center px-lg-5 px-4 py-5">
                            <div className="card no-shadow m-auto p-4 bg-light-gray text-center" style={
                                {
                                    Width: '542px',
                                }
                            }>
                                <h2 className="card-title fw-bold mb-3">Olvidaste tu Contraseña</h2>
                                <div className="card-body">
                                    <p className='my-4'>
                                        Te enviaremos las instrucciones para restablecer tu contraseña por correo electrónico
                                    </p>
                                    <form action="">
                                        {renderPasswordRequestForm()}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main >
            <ModalComponent
                id='alertModal'
                title={modalTitle}
                show={showModal}
                setShow={setShowModal}
                callbackOnHide={handleCallbackOnHide}
                callbackData={callbackData}
            >
                <p>
                    {modalBody}
                </p>
                <div className='d-flex justify-content-end mt-4'>
                    <button
                        type='button'
                        className='btn btn-secondary'
                        onClick={() => {
                            setShowModal(false)
                        }}
                    >
                        Ok
                    </button>
                </div>
            </ModalComponent>
        </>
    )
}
